/*! hm-lazy.js – tiny IntersectionObserver replacement for lazysizes (Happy Mining).
 * Handles the markup lazysizes expects: .lazyload + data-src / data-srcset / data-sizes="auto" / data-bg,
 * adds the lazyloading / lazyloaded classes and fires the "lazyloaded" event the theme listens to.
 * Unlike lazysizes it never measures every image on scroll, so it causes no forced layouts.
 * Until the page has finished loading only the images inside the viewport are fetched (nothing competes with
 * the hero image and the fonts); afterwards images are fetched 400 px ahead of the viewport.
 * Also fills the "trending products" of the search panels on demand (see snippets/quick-searching-trending-products.liquid). */
(function () {
  'use strict';
  /* Is this event a visitor's gesture? The first-gesture listeners capture on window, so they also see (1) the scroll
     events of sliders the theme scrolls by script and (2) the synthetic mousemove Chrome sends after a layout change when
     the pointer sits over the page (movement 0) – neither is the visitor (same test inlined in global-script / hm-app-delay). */
  window.hmIsGesture = window.hmIsGesture || function (e) {
    if (!e || !e.type) return true;
    if (e.type === 'scroll') return e.target === document || e.target === window;
    if (e.type === 'mousemove') return !!(e.movementX || e.movementY);
    return true;
  };
  var SEL = '.lazyload, [data-srcset], [data-bg]';
  var supported = 'IntersectionObserver' in window;
  function unveil(el, rectWidth) {
    if (el.__hmUnveiled) return;
    el.__hmUnveiled = true;
    var sizes = el.getAttribute('data-sizes');
    if (sizes === 'auto' && el.hasAttribute('data-srcset') && !el.hasAttribute('sizes')) {
      // the observer entry already carries the box: no getBoundingClientRect (a forced layout) per image
      var w = rectWidth || el.getBoundingClientRect().width || (el.parentNode && el.parentNode.getBoundingClientRect().width) || 0;
      if (w) el.setAttribute('sizes', Math.ceil(w) + 'px');
    } else if (sizes) el.setAttribute('sizes', sizes);
    if (el.tagName === 'PICTURE' || el.parentNode && el.parentNode.tagName === 'PICTURE') {
      var pic = el.tagName === 'PICTURE' ? el : el.parentNode;
      var sources = pic.querySelectorAll('source[data-srcset]');
      for (var i = 0; i < sources.length; i++) { sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset')); sources[i].removeAttribute('data-srcset'); }
    }
    var srcset = el.getAttribute('data-srcset'); if (srcset) { el.setAttribute('srcset', srcset); el.removeAttribute('data-srcset'); }
    var src = el.getAttribute('data-src'); if (src) { el.setAttribute('src', src); el.removeAttribute('data-src'); }
    var bg = el.getAttribute('data-bg'); if (bg) { el.style.backgroundImage = 'url(' + bg + ')'; el.removeAttribute('data-bg'); }
    el.classList.remove('lazyload');
    var done = function () {
      el.classList.remove('lazyloading');
      el.classList.add('lazyloaded');
      try { el.dispatchEvent(new CustomEvent('lazyloaded', { bubbles: true })); } catch (e) {}
    };
    if ((el.tagName === 'IMG' || el.tagName === 'IFRAME') && !(el.tagName === 'IMG' && el.complete && el.naturalWidth)) {
      el.classList.add('lazyloading');
      el.addEventListener('load', done, { once: true });
      el.addEventListener('error', done, { once: true });
    } else done();
  }
  var pending = [], io = null;
  /* Images that come into range together (a whole grid after the load event) are unveiled a few per task, so no
     single task blocks the main thread for long (each unveil can cost a style/layout pass). */
  var queue = [], draining = false;
  function drain() {
    var t0 = Date.now(), item;
    while (queue.length && Date.now() - t0 < 12) { item = queue.shift(); unveil(item[0], item[1]); }
    if (queue.length) setTimeout(drain, 0); else draining = false;
  }
  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { io.unobserve(entries[i].target); queue.push([entries[i].target, entries[i].boundingClientRect && entries[i].boundingClientRect.width]); }
    if (queue.length && !draining) { draining = true; drain(); }
  }
  function setMargin(margin) {
    if (!supported) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(onIntersect, { rootMargin: margin });
    var keep = [];
    for (var i = 0; i < pending.length; i++) if (!pending[i].__hmUnveiled) { keep.push(pending[i]); io.observe(pending[i]); }
    pending = keep;
  }
  function watch(root) {
    var els = (root.matches && root.matches(SEL)) ? [root] : [];
    var found = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < found.length; i++) els.push(found[i]);
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.__hmWatched || el.__hmUnveiled) continue;
      el.__hmWatched = true;
      if (el.tagName === 'SOURCE') continue;
      if (io) { pending.push(el); io.observe(el); } else unveil(el);
    }
  }
  var wide = false;
  function widen(e) { if (wide || !window.hmIsGesture(e)) return; wide = true; setMargin('400px 0px'); }
  function start() {
    setMargin(document.readyState === 'complete' ? '400px 0px' : '0px 0px');
    if (document.readyState === 'complete') wide = true; else window.addEventListener('load', function () { setTimeout(widen, 0); });
    var evs = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
    // (a slider scrolled by script also fires a captured 'scroll': only the page's own scroll counts, see widen)
    for (var i = 0; i < evs.length; i++) window.addEventListener(evs[i], widen, { passive: true, capture: true });
    watch(document);
    if ('MutationObserver' in window) {
      // one pass per frame over the nodes the theme scripts inserted (never the whole document again)
      var added = [], queued = false;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) for (var k = 0; k < muts[i].addedNodes.length; k++) { var n = muts[i].addedNodes[k]; if (n.nodeType === 1) added.push(n); }
        if (queued || !added.length) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; var list = added; added = []; for (var i = 0; i < list.length; i++) if (list[i].isConnected) watch(list[i]); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    trending();
  }
  /* Trending products of the search panels: the cards are not in the page HTML (they were ~75 KB, rendered
     three times); they are fetched once, the first time a visitor opens a search field. */
  function trending() {
    var boxes = document.querySelectorAll('[data-hm-trending]');
    if (!boxes.length) return;
    var loading = false;
    function load() {
      if (loading) return; loading = true;
      var url = boxes[0].getAttribute('data-hm-trending');
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-hm-trending-grid]');
        if (!grid) return;
        var base = grid.innerHTML;
        for (var i = 0; i < boxes.length; i++) {
          var target = boxes[i].querySelector('.products-grid') || boxes[i];
          // the same cards go into several panels: keep ids unique
          target.innerHTML = i === 0 ? base : base.replace(/(\s(?:id|for|form|data-form-id)=")([^"]+)"/g, '$1$2-hm' + i + '"');
          boxes[i].removeAttribute('data-hm-trending');
        }
        if (window.jQuery && window.halo) {
          try { if (window.wishlist && window.wishlist.show) window.halo.setLocalStorageProductForWishlist(); } catch (e) {}
        }
      }).catch(function () { loading = false; });
    }
    function onOpen(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('form[action*="/search"], .search-modal, #search-form-mobile, .halo-sidebar-search, [data-open-search], .header__search, .search-icon, [data-search-toggle], [data-search-mobile], .hm-header__icon--search')) {
        load();
        document.removeEventListener('focusin', onOpen, true);
        document.removeEventListener('pointerdown', onOpen, true);
      }
    }
    document.addEventListener('focusin', onOpen, true);
    document.addEventListener('pointerdown', onOpen, true);
  }
  // Dynamic checkout buttons (snippets/hm-payment-button.liquid): their markup waits in a <template> and is put in place
  // at the visitor's first touch, click, key, scroll or mouse move – the PayPal SDK is not loaded for a page nobody uses.
  (function () {
    // (no 'focusin': keyboard users press a key first; 'scroll' only for the page itself – the listeners capture, so they
    // also see the scroll events of sliders that the theme scrolls by script while the page loads)
    var EVS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'], done = false;
    function place() {
      var ts = document.querySelectorAll('template[data-hm-pay]');
      for (var i = 0; i < ts.length; i++) {
        var t = ts[i], ph = t.nextElementSibling;
        t.parentNode.replaceChild(t.content.cloneNode(true), t);
        if (ph && ph.classList && ph.classList.contains('hm-pay-ph')) ph.parentNode.removeChild(ph);
      }
    }
    function go(e) {
      if (done || !window.hmIsGesture(e)) return;
      done = true;
      try { performance.mark('hm:pay:' + (e ? e.type : 'input')); } catch (x) {}
      EVS.forEach(function (e) { window.removeEventListener(e, go, true); });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
    }
    if (window.hmInputSeen) go();
    else EVS.forEach(function (e) { window.addEventListener(e, go, { passive: true, capture: true }); });
  })();
  // minimal lazySizes API surface for code that calls it
  window.lazySizes = window.lazySizes || {
    cfg: window.lazySizesConfig || {},
    loader: { checkElems: function () { watch(document); }, unveil: unveil },
    init: function () {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
